// Rules for the key of a custom permission — the name views and processes check, so the form
// normalizes what is typed and refuses a key that another permission or a resource prefix owns.
import l from "components/util/l";
import { getPermissionTarget } from "components/util/permissions";

// Keys are snake_case ASCII: accents are dropped, anything else becomes an underscore.
export const toPermissionKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

// `takenKeys` are every flow-level key of the flow; the permission's own key is not a clash.
export const getKeyError = (key, originalKey, takenKeys) => {
  if (!key) return null;
  if (getPermissionTarget(key) != "flow") return l("Nombre reservado%PA893");
  if (key !== originalKey && takenKeys.includes(key)) return l("Ya existe un permiso con esa clave%VG378");
  return null;
};

export const omitKey = (map, key) => {
  const { [key]: removed, ...rest } = map;
  return rest;
};
